export interface IParameterAnswer {
    guid: string;
    answerValue: number;
    forcedAnswerValue?: number;
    answerTitle?: string;
    timeAnswered: string;
    remark: string;
    isSubmitted?: boolean;
    timeSubmitted?: string;
    parameterGuid: string;
    parameterName?: string;
    countryGuid: string;
    countryName: string;
}

export const initParameterAnswer: IParameterAnswer = {
    guid: "",
    answerValue: 0,
    remark: "",
    timeAnswered: "",
    parameterGuid: "",
    countryGuid: "",
    countryName: "",
    isSubmitted: false,
    timeSubmitted: "",
};
